"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardsFilter = void 0;
var vue_1 = require("vue");
var AllCards_1 = require("../../cards/AllCards");
var TranslateMixin_1 = require("../TranslateMixin");
var allItems = AllCards_1.ALL_PROJECT_CARD_NAMES.concat(AllCards_1.ALL_PRELUDE_CARD_NAMES).sort();
exports.CardsFilter = vue_1.default.component('cards-filter', {
    props: {},
    data: function () {
        return {
            selectedCardNames: [],
            foundCardNames: [],
            searchTerm: '',
        };
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    methods: {
        isPrelude: function (cardName) {
            return AllCards_1.ALL_PRELUDE_CARD_NAMES.includes(cardName);
        },
        removeCard: function (cardNameToRemove) {
            this.selectedCardNames = this.selectedCardNames.filter(function (curCardName) { return curCardName !== cardNameToRemove; }).sort();
        },
        addCard: function (cardNameToAdd) {
            if (this.selectedCardNames.includes(cardNameToAdd))
                return;
            this.selectedCardNames.push(cardNameToAdd);
            this.selectedCardNames.sort();
            this.searchTerm = '';
        },
    },
    watch: {
        selectedCardNames: function (value) {
            this.$emit('cards-list-changed', value);
        },
        searchTerm: function (value) {
            var _this = this;
            if (value === '') {
                this.foundCardNames = [];
                return;
            }
            if (value.indexOf(',') !== -1) {
                var cardNames = new Set(value.split(',').map(function (c) { return c.trim(); }));
                for (var _i = 0, allItems_1 = allItems; _i < allItems_1.length; _i++) {
                    var item = allItems_1[_i];
                    if (cardNames.has(item)) {
                        this.addCard(item);
                    }
                }
                return;
            }
            var newCardNames = allItems.filter(function (candidate) { return !_this.selectedCardNames.includes(candidate) && candidate.toLowerCase().indexOf(value.toLowerCase()) !== -1; }).sort();
            this.foundCardNames = newCardNames.slice(0, 5);
        },
    },
    template: "\n    <div class=\"cards-filter\">\n        <h2 v-i18n>Cards to exclude from the game</h2>\n        <div class=\"cards-filter-results-cont\" v-if=\"selectedCardNames.length\">\n            <div class=\"cards-filter-result\" v-for=\"cardName in selectedCardNames\">\n                <label>{{ cardName }}<i class=\"create-game-expansion-icon expansion-icon-prelude\" title=\"This card is prelude\" v-if=\"isPrelude(cardName)\"></i></label>\n                <Button size=\"small\" type=\"close\" :onClick=\"_=>removeCard(cardName)\" /> \n            </div>\n        </div>\n        <div class=\"cards-filter-input\">\n            <div>\n                <input class=\"form-input\" :placeholder=\"$t('Start typing the card name to exclude')\" v-model=\"searchTerm\" />\n            </div>\n            <div class=\"cards-filter-suggest\" v-if=\"foundCardNames.length\">\n                <div class=\"cards-filter-suggest-item\" v-for=\"cardName in foundCardNames\">\n                    <a href=\"#\" v-on:click.prevent=\"addCard(cardName)\">\n                      {{ cardName }}\n                      <i class=\"create-game-expansion-icon expansion-icon-prelude\" title=\"This card is prelude\" v-if=\"isPrelude(cardName)\"></i>\n                    </a> \n                </div>\n            </div>\n        </div>\n    </div>\n    ",
});
//# sourceMappingURL=CardsFilter.js.map